import { LifeCycle } from '@/domain/lifeCycles/types';
import { Chip } from '@andritzot/metris-web-ui/data-display/chip';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';
import React, { Fragment } from 'react';

interface PlantLifeCycleContentProps {
  ProductLifeCycles: LifeCycle[];
}

const PlantLifeCycleContent: React.FC<PlantLifeCycleContentProps> = ({ ProductLifeCycles }) => {
  return (
    ProductLifeCycles?.length > 0 && (
      <Box sx={{ display: 'flex', flexWrap: 'wrap', m: 2, gap: 2 }}>
        {ProductLifeCycles?.map((lifeCycle) => (
          <Fragment key={lifeCycle.idLifeCycle}>
            <Chip label={lifeCycle.lifeCycle} variant="outlined" color="primary" />
          </Fragment>
        ))}
      </Box>
    )
  );
};

export default PlantLifeCycleContent;
